var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommonProblem = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10059 9.47063C5.10059 6.7139 7.33536 4.47913 10.0921 4.47913H33.6341C36.3908 4.47913 38.6256 6.7139 38.6256 9.47063V11.3083V24.2487C38.6256 26.7805 35.4497 27.9142 33.8465 25.9547V25.9547C33.3348 25.3293 32.5695 24.9666 31.7614 24.9666H10.0921C7.33536 24.9666 5.10059 22.7318 5.10059 19.9751V9.47063Z",
    fill: "url(#paint0_linear_3451_61083)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 13.1957C1.375 10.4389 3.60977 8.20416 6.3665 8.20416H29.9085C32.6652 8.20416 34.9 10.4389 34.9 13.1957V15.0333V32.025C34.9 33.1977 33.4289 33.7229 32.6863 32.8152L30.8103 30.5223C29.8623 29.3636 28.4442 28.6917 26.9471 28.6917H6.3665C3.60977 28.6917 1.375 26.4569 1.375 23.7002V13.1957Z",
    fill: "url(#paint1_linear_3451_61083)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.307 18.1375C11.307 19.1661 10.4732 20 9.44453 20C8.4159 20 7.58203 19.1661 7.58203 18.1375C7.58203 17.1088 8.4159 16.275 9.44453 16.275C10.4732 16.275 11.307 17.1088 11.307 18.1375ZM19.9988 18.1375C19.9988 19.1661 19.1649 20 18.1363 20C17.1076 20 16.2738 19.1661 16.2738 18.1375C16.2738 17.1088 17.1076 16.275 18.1363 16.275C19.1649 16.275 19.9988 17.1088 19.9988 18.1375ZM26.827 20C27.8557 20 28.6895 19.1661 28.6895 18.1375C28.6895 17.1088 27.8557 16.275 26.827 16.275C25.7984 16.275 24.9646 17.1088 24.9646 18.1375C24.9646 19.1661 25.7984 20 26.827 20Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3451_61083",
    x1: 21.8631,
    y1: 4.47913,
    x2: 21.8631,
    y2: 31.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3451_61083",
    x1: 18.1375,
    y1: 8.20416,
    x2: 18.1375,
    y2: 35.5208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommonProblem);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/common-problem.0a32de0427bf61d4cbd3c910a2982010.svg";